export default __webpack_public_path__ + "static/media/linkIcon.7f9eb89a.svg";